import { useAppDispatch } from 'dux/app/hooks';

import { Text, theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { BackgroundVideo } from 'Blocks/BackgroundVideo';

import ConsultationCTA from 'Containers/ConsultationCTA';

import { heroContent } from 'assets/content/homeV2';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import { trackHeapEvent } from 'dux/tracking/actions';

const CardWrapper = styled.div`
  width: 100%;
  border-radius: ${theme.radius.xs};
  overflow: hidden;
`;

const VideoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['2x']};

  padding: ${theme.spacing['8x']} ${theme.spacing['4x']};
  height: 100%;

  ${legacyTheme.breakpoints.up('sm')} {
    gap: ${theme.spacing['4x']};
    justify-content: center;
    max-width: 341px;
    margin-left: 66%;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-self: center;
  padding: ${theme.spacing['4x']} 0;

  ${legacyTheme.breakpoints.up('sm')} {
    position: initial;
    transform: unset;
    justify-content: flex-start;
    padding: 0;
  }
`;

type HomeHeroProps = {
  heroRef: (node?: Element | null | undefined) => void;
};

export const HomeHero = ({ heroRef }: HomeHeroProps) => {
  const dispatch = useAppDispatch();
  const { isMobile } = useResponsiveVariant();
  const { backgroundVideo, backgroundVideoPosterImage, imgAlt, headline, eyebrow } = heroContent;

  return (
    <>
      <CardWrapper data-testid="home-revamp-hero">
        <BackgroundVideo
          autoplayDelay={1000}
          imageAlt={imgAlt}
          onPause={() => dispatch(trackHeapEvent('Video paused'))}
          onPlay={() => dispatch(trackHeapEvent('Video played'))}
          posterImages={backgroundVideoPosterImage}
          videoSources={backgroundVideo}
        >
          <VideoTextWrapper ref={heroRef}>
            <Text color="neutral.100" variant="labelSm">
              {eyebrow}
            </Text>
            <Text as="h1" color="neutral.100" data-testid="home-hero-headline" variant="heading5">
              {headline}
            </Text>
            {!isMobile && (
              <ButtonContainer>
                <ConsultationCTA
                  css={{
                    width: '274px',
                  }}
                  data-id="home-hero-cta"
                  data-testid="home-hero-cta"
                  dataFrom="homepage-hero"
                  noMargin
                  variant="roundedBlack"
                />
              </ButtonContainer>
            )}
          </VideoTextWrapper>
        </BackgroundVideo>
      </CardWrapper>

      {isMobile && (
        <ButtonContainer>
          <ConsultationCTA
            css={{
              width: '274px',
            }}
            data-id="home-hero-cta"
            data-testid="home-hero-cta"
            dataFrom="homepage-hero"
            hasBoxShadow
            noMargin
            variant="roundedBlack"
          />
        </ButtonContainer>
      )}
    </>
  );
};
